'use strict';

class originatorService {
  constructor($http, $location, $cacheFactory) {
    this.$http = $http;
    this.$location = $location;
    this.$cacheFactory = $cacheFactory;

    this.collectionAgencies = [];

    this.originatorCache = $cacheFactory('originator-cache', { capacity: 5 });
  }

  get() {
    return this.$http.get('/originators/current', {
      cache: this.originatorCache
    });
  }

  getForce() {
    this.originatorCache.removeAll();

    return this.$http({
      method: 'GET',
      url: `/originators/current`,
      ignoreAuth: true,
      cache: this.originatorCache
    });
    // return this.$http.get('/originators/current', {
    //   cache: this.originatorCache
    // });
  }

  generateOtp(params) {
    return this.$http.post('/originators/current/generateOtp', params);
  }

  confirmOtp(params) {
    return this.$http.post('/originators/current/confirmOtp', params);
  }

  confirm(params) {
    return this.$http.post('/originators/current/confirm', params);
  }

  getConfirm() {
    return this.get()
      .then((resp) => {
        // check date to be older then 3 months
        if (moment(resp.data.lastConfirmed, 'YYYY-MM-DD').diff(moment().subtract(3, 'months')) < 0) {
          // alert user
          this.settings()
            .then((resp2) => {
              swal({
                title: 'Bekreft adresseinformasjon',
                text: `<div>
                  <p>Vennligst kontroller at adresseinformasjonen stemmer.</p>
                  <table style='margin-top: 10px;'>
                    <tr>
                      <td class='left-align'>Kontakt e-postadresse</td>
                      <th class='left-align'>${resp2.data.sendRegningContactEmail}</th>
                    </tr>
                    <tr>
                      <td class='left-align'>Navn</td>
                      <th class='left-align'>${resp.data.name}</th>
                    </tr>
                    <tr>
                      <td class='left-align'>Postadresse</td>
                      <th class='left-align'>
                        ${resp.data.contact.address.address1} ${resp.data.contact.address.address2},
                        ${resp.data.contact.address.zip} ${resp.data.contact.address.city} ${resp.data.contact.address.country}
                      </th>
                    </tr>
                    <tr>
                      <td class='left-align'>Telefon</td>
                      <th class='left-align'>${resp.data.contact.mobile || ''}</th>
                    </tr>
                  </table>
                  <p>Stemmer disse opplysningene?</p>
                </div>`,
                html: true,
                showCancelButton: true,
        showCloseButton
    :
      true,
        confirmButtonColor: '#970b0e',
                confirmButtonText: 'Nei',
                cancelButtonText: 'Ja',
                customClass: 'confirmAddress',
        closeOnConfirm
    :
      true,
        allowOutsideClick
    :
      true
              }, (answer) => {
                this.confirm();

                if (answer) {
                  this.$location.path('/konto');
                }
              });
            });
        }
      });
  }

  update(params) {
    this.originatorCache.removeAll();
    return this.$http.put('/originators/current', params);
  }

  settings() {
    return this.$http.get('/originators/current/settings');
  }

  updateSettings(params) {
    this.originatorCache.removeAll();
    return this.$http.put('/originators/current/settings', params);
  }

  register(data, captcha) {
    return this.$http.post('/originators/', data, {
      headers: {
        Captcha: captcha || ''
      }
    });
  }

  nextDocumentNumber() {
    return this.$http.get('/originators/current/suggest');
  }

  getUsersOfOriginator(id) {
    return this.$http.get(`/originators/${id}/users`);
  }

  removeLinkedUsers(id, userId) {
    return this.$http.post(`/originators/${id}/users/${userId}/remove`);
  }

  inviteOriginator(id, email) {
    return this.$http.post(`/originators/${id}/invite`, {
      email: email
    });
  }

  removeInvite(id, email) {
    return this.$http.post(`/originators/${id}/invite/remove`, {
      email: email
    });
  }

  select(id) {
    return this.$http.post(`/originators/${id}/select`);
  }

  validateLink(id, params) {
    return this.$http.post(`/originators/public/${id}/invite/validate`, params);
  }

  acceptInvite(id, params) {
    return this.$http.post(`/originators/public/${id}/invite/accept`, params);
  }

  getCreditors() {
    return this.$http.get('/originators/current/creditors');
  }

  validateDeactivate() {
    return this.$http.get(`/originators/current/deactivate/validate`);
  }

  deactivate(params) {
    return this.$http.post(`/originators/current/deactivate`, params);
  }

  validateDelete() {
    return this.$http.get(`/originators/current/delete/validate`);
  }

  delete(params) {
    return this.$http.post(`/originators/current`, params);
  }

  validateDownload() {
    return this.$http.get(`/originators/current/data/validate`);
  }

  downloadAllData(applicationType, includeAudit) {
    return this.$http.get(`/originators/current/data?audit=` + includeAudit, {
      headers: {
        Accept: 'application/' + applicationType
      },
      responseType: 'arraybuffer'
    }).then((resp) => {
      if (resp) {
        const filename = resp.headers()['content-disposition'] ? resp.headers()['content-disposition'].match(/filename="(.+)"/)[1] : 'srrapport';
        const contentType = resp.headers()['content-type'];

        saveAs(new Blob([resp.data], {
          type: contentType
        }), filename);
      } else {
        return true;
      }
    });
  }

  downloadRecipientData(applicationType, recipientNumber) {
    return this.$http.get(`/originators/current/recipients/` + recipientNumber + '/data', {
      headers: {
        Accept: 'application/' + applicationType
      },
      responseType: 'arraybuffer'
    }).then((resp) => {
      if (resp) {
        const filename = resp.headers()['content-disposition'] ? resp.headers()['content-disposition'].match(/filename="(.+)"/)[1] : 'srrapport';
        const contentType = resp.headers()['content-type'];

        saveAs(new Blob([resp.data], {
          type: contentType
        }), filename);
      } else {
        return true;
      }
    });
  }

  // Logo
  getLogo(id) {
    return this.$http.get(`/originators/${id}/logo?format=base64`);
  }

  uploadLogo(params) {
    return this.$http.post('/originators/current/logo', params);
  }

  deleteLogo() {
    return this.$http.delete('/originators/current/logo');
  }

  getEFaktura2() {
    return this.$http.get('/originators/current/efaktura2');
  }

  registerEFaktura2(name) {
    return this.$http.post('/originators/current/efaktura2', {
      name: name
    });
  }

  deleteEFaktura2() {
    return this.$http.delete('/originators/current/efaktura2');
  }

  // OCR
  getOCR() {
    return this.$http.get(`/originators/current/ocr`);
  }

  registerOCR(params = {}) {
    return this.$http.post(`/originators/current/ocr`, params);
  }
}

originatorService.$inject = ['$http', '$location', '$cacheFactory'];

angular
  .module('SendRegning')
  .service('originatorService', originatorService);
